import { Box, BoxProps } from "@chakra-ui/react";

export function EditIcon({ ...props }: BoxProps) {
  return (
    <Box cursor={'pointer'} {...props}>
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_2589_2791)">
          <path d="M9.38245 2.59034C9.87924 2.05209 10.1276 1.78297 10.3916 1.62599C11.0285 1.24721 11.8127 1.23543 12.4602 1.59492C12.7286 1.74391 12.9846 2.00545 13.4967 2.52855C14.0087 3.05164 14.2648 3.31319 14.4106 3.58732C14.7625 4.24878 14.751 5.0499 14.3802 5.70051C14.2265 5.97014 13.9631 6.22389 13.4362 6.73138L7.16706 12.7696C6.16856 13.7313 5.66931 14.2121 5.04535 14.4559C4.42139 14.6996 3.73545 14.6816 2.36356 14.6458L2.1769 14.6409C1.75925 14.6299 1.55043 14.6245 1.42904 14.4867C1.30765 14.349 1.32422 14.1363 1.35737 13.7108L1.37536 13.4798C1.46865 12.2824 1.5153 11.6837 1.74912 11.1455C1.98294 10.6073 2.38627 10.1703 3.19293 9.29637L9.38245 2.59034Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" />
          <path d="M8.66663 2.66675L13.3333 7.33341" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" />
          <path d="M9.33331 14.6667L14.6666 14.6667" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </g>
        <defs>
          <clipPath id="clip0_2589_2791">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </Box>
  );
}
